import React, { useEffect } from "react";
import "./Blog_inner.css";
import Breadcrumb_comp from "../../common-components/breadcrumb-comp/Breadcrumb_comp";
import Stay_Connected from "../../home/stay_Connected/Stay_Connected";
import Back_text_holder from "../../common-components/back_text_holder/Back_text_holder";
import { useDispatch, useSelector } from "react-redux";
import { getblogById } from "../../../features/blog/Slice";
import { useParams } from "react-router-dom";
import { format } from "date-fns";
import parse from "html-react-parser";
import { formatDate } from "../../../utils/common";

function Blog_inner() {
  const { id } = useParams();

  const blog = useSelector((state) => state.blog.blog);
  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false },
    { label: "BLOGS", link: "/blog", isActive: false },
    { label: blog?.name, link: "", isActive: true },
  ];
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getblogById(id));
  }, [dispatch, id]);

  return (
    <>
      <section className="Blog_inner">
        <Breadcrumb_comp breadcrumbs={breadcrumbs} />
        <div className="container-fluid">
          <div className="Blog_inner_holder">
            <div className="blog-content">
              <div className="content_div">
                <div className="float-image">
                  <img
                    src={process.env.REACT_APP_IMG_URL + blog?.image}
                    alt="Blog_inner_img"
                    className="Blog_inner_img"
                  />
                </div>

                <div className="text_holder">
                  <h4 className="heading_text">{blog?.name}</h4>
                  <span className="date_text para_text">
                    Last Updated on :- {formatDate(blog?.updatedAt)}
                  </span>

                  <p>{blog?.subname}</p>

                  <div className="para_text">
                    {parse(
                      typeof blog?.description === "string"
                        ? blog.description
                        : "",
                    )}
                  </div>
                </div>
              </div>
            </div>
            <Back_text_holder baseLink="/blog" backText="Blog" />
          </div>
        </div>
      </section>
    </>
  );
}

export default Blog_inner;
